module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jamale Ijouiher\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("A graduate of Liverpool John Moores University with a degree in Palaeobiology and Evolution, Jamale Ijouiher is an expert on Mesozoic African biota. Ijouiher has participated in fieldwork in Britain and Morocco.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/YZyWHV/tc-custom/9780253063335.jpg?1726273531652",
      "alt": "This image is the cover for the book Desert Bones, Life of the Past"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Desert Bones, Life of the Past\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("An essential introduction to the age of dinosaurs in Africa."), _c('br')]), _vm._v("Once Africa was referred to as the ''Lost World of the dinosaur era,'' so poorly known were its ancient flora and fauna. Worse still, many priceless fossil specimens from the Sahara Desert were destroyed during the Second World War. Fortunately, in the twentieth-first century, more researchers are now working in north Africa than ever before and making fascinating discoveries such as the dinosaur "), _c('i', [_vm._v("Spinosaurus. ")]), _vm._v("Based on a decade of study, "), _c('i', [_vm._v("The Desert Bones")]), _vm._v(" brings the world of African dinosaurs fully into the light. Jamale Ijouiher skillfully draws on the latest research and knowledge about paleoecology to paint a compelling and comprehensive portrait of the mid-Cretaceous in North Africa.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0